import { apiSlice } from './apiSlice';
import { t } from '../../i18n/i18n';

/**
 * Pre-launch sign-ups — the "notify me" forms on Alpha DNA, Alpha OPS and
 * Divento.
 *
 *   POST /product-launch/subscribe/ ← { product, email }
 *     product: 'alpha_dna' | 'alpha_ops' | 'divento'
 *     201 the first sign-up, 200 the saved email replaced — both mean the
 *     trader is on the list. 400 carries field messages ({ email: [...] }),
 *     429 comes after ten requests in an hour.
 *
 * There is no GET, so after a reload the page can't tell that the trader
 * already signed up; sending again is safe and only replaces the email.
 */
export const productLaunchApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    subscribeProductLaunch: builder.mutation({
      query: ({ product, email }) => ({
        url: '/product-launch/subscribe/',
        method: 'POST',
        body: { product, email },
      }),
    }),
  }),
});

export const { useSubscribeProductLaunchMutation } = productLaunchApi;

/** What to tell the trader when a sign-up fails, from the error RTK Query hands back. */
export const subscribeErrorMessage = (error) => {
  const field = error?.data?.email?.[0] ?? error?.data?.product?.[0];
  if (error?.status === 400 && field) return t(field);
  if (error?.status === 429) return t('Too many attempts. Try again in a few minutes.');
  if (error?.status === 401) return t('Your session has expired. Please sign in again.');
  return t('Something went wrong. Please try again.');
};
